"use strict";

Shopify.theme.jsVideo = {
  init: function init($section) {
    var $this = this;
    
    this.lazyload(() => {
      // Add settings from schema to current object
      Shopify.theme.jsVideo = $.extend(this, Shopify.theme.getSectionData($section)); // Selectors

      if ($section.find('.featured-videos__container-column').length) {
        $section = $section.find('.featured-videos__container-column');
      }

      $section.each(function () {
        var $videoElement = $(this).find('[data-video-element]');
        var $playButton = $(this).find('[data-play-button]');
        var $videoTextContainer = $(this).find('[data-video-text-container]');
        var $imageElement = $(this).find('[data-image-element]'); // Load video if the media has been added

        if ($this.iframe_video || $this.html5_video) {
          $this.loadVideo($videoElement, $playButton, $videoTextContainer, $imageElement);
        } else {
          $imageElement.show();
        }
      });
    });
  },
  lazyload: function lazyload(callback = () => {}) {
    $(window).on('scroll',lazyload);
    function lazyload(){
      $('[data-video-element]').addClass('plyr__video-wrapper plyr__video-embed');
      $('.mr-lazy-load-iframe').each(function(){
        if(!$(this).hasClass('lazyloaded')) {
          $(this).attr('src', $(this).data('src'));
          $(this).addClass('lazyloaded');
        }
      });
      if(!$('.mr-lazy-load-iframe').not('.lazyloaded').length) {
        $(window).off('scroll',lazyload);
        callback();
      }
    }
  },
  loadVideo: function loadVideo($videoElement, $playButton, $videoTextContainer, $imageElement) {
    var blockID = $videoTextContainer.closest('.featured-videos__container-column').data('block-id');
    var player = new Plyr(".video-".concat(this.id), {
      controls: videoControls,
      loop: {
        active: this.autoloop
      },
      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true
      },
      storage: {
        enabled: false
      }
    });
    player.muted = this.mute;
    player.ratio = this.aspect_ratio; // If autoplay enabled, hide image and text

    if (this.autoplay) {
      player.autoplay = true;
      $imageElement.hide();
      $videoTextContainer.hide();
    } else {
      $imageElement.show();
      $videoTextContainer.show();
    } // If button exists, on click show video and hide image/text


    if (this.button) {
      $playButton.on('click', function () {
        player.play();
      });
    } // On player ready, hide play icon if play button visible


    player.on('ready', function (index, player) {
      if ($videoTextContainer && Shopify.theme.jsVideo.button) {
        $videoElement.closest('.video-wrapper').find('.plyr--paused.plyr--video .plyr__control--overlaid').hide();
      } else {
        $videoElement.closest('.video-wrapper').find('.plyr--paused.plyr--video .plyr__control--overlaid').show();
      }
    }); // On player pause, show play icon if play button hidden

    player.on('pause', function (index, player) {
      $videoElement.closest('.video-wrapper').find('.plyr--paused.plyr--video .plyr__control--overlaid').show();
    }); // Clicking anywhere on video should play the video

    $('.featured-videos__tab-content .modal-wrapper').on('click', function(event) {
      if (!$(event.target).closest('.modal').length) {
        player.pause();
        $('.modal-wrapper').removeClass('open-modal');
        $('html').removeClass('modal-is-open');
      }
    }); // Pause all videos on modal close

    $videoTextContainer.closest('.featured-videos__tab-content').find('[data-icon="x"]').on('click', function () {
      player.pause();
      $('.modal-wrapper').removeClass('open-modal');
      $('html').removeClass('modal-is-open');
    });

    $videoTextContainer.on('click', function () {
      setTimeout(function () {
        player.play();
        $('.modal-wrapper.modal-'  + blockID).addClass('open-modal');
        $('html').addClass('modal-is-open');
      }, 250);
    });
  },
  unload: function unload($section) {
    var $playButton = $section.find('[data-play-button]');
    var $videoTextContainer = $section.find('[data-video-text-container]');
    $playButton.off();
    $videoTextContainer.off();
  }
};